// @ts-nocheck
import type { ReactNode } from 'react'
import styled from 'styled-components'

export const Container = styled.div<{
  isOpen: boolean
  children?: ReactNode
}>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 900;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  pointer-events: ${({ isOpen }) => (isOpen ? 'all' : 'none')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;
`
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 48px;
  border-radius: 8px;
  p {
    text-align: center;
  }
  max-height: 80vh;
  overflow: auto;
`
export const StepContainer = styled.div`
  padding: 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const ButtonsContainer = styled.section`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 16px;
`
export const InputWrapper = styled.div`
  position: relative;
`

export const StyledInput = styled.input<{
  placeholder?: string
  name?: string
  value?: string
  type?: string
  onChange: (e: any) => void
  onBlur: (e: any) => void
}>`
  width: max-content;
  height: 60px;
  border-radius: 8px;
  outline: 0;
  border: 0;
  background: #f3f4f5;
  font-size: 16px;
  padding-left: 48px;
  min-width: 420px;
  &:focus {
    border: 1px solid #8601c9;
    background: #ffffff;
  }
  &::placeholder {
    font-size: 16px;
    color: #39383a;
    padding-left: 8px;
  }
  &:not(:placeholder-shown) {
    border: 1px solid #8601c9;
    background: #ffffff;
  }
`

export const ErrorText = styled.p`
  color: #c62828;
  margin-top: 8px;
  font-size: 14px;
`

export const TicketList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`

export const TicketOption = styled.button<{
  selected?: boolean
  type?: string
  onClick: () => void
  children?: ReactNode
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid ${({ selected }) => (selected ? '#8601c9' : '#d0d0d0')};
  background: ${({ selected }) => (selected ? '#f7ecff' : '#ffffff')};
  cursor: pointer;
  text-align: left;

  strong {
    font-size: 14px;
    color: #39383a;
  }

  span {
    font-size: 12px;
    color: #6b6b6b;
  }
`
